export default __webpack_public_path__ + "static/media/fi_above_12.fe13c6b9.png";